import { render, staticRenderFns } from "./AdminUserTabularHeader.vue?vue&type=template&id=af964ce4&"
import script from "./AdminUserTabularHeader.vue?vue&type=script&lang=ts&"
export * from "./AdminUserTabularHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports